import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { SocioEmotionalSkill } from '../socio-emotional-skills-test/socio-emotional-skills-test.models';
import { SocioEmotionalSkillTestResult } from '../socio-emotional-skills-test-results/socio-emotional-skills-test-results.models';
import { ApiService } from '../services/api.service';
import { SchoolSocioEmotionalDashboardFilter } from './school-socio-emotional-dashboard-filters/school-socio-emotional-dashboard-filters.models';

const SOCIO_EMOTIONAL_SKILLS_ENDPOINT = 'api/socioEmotionalSkills';
const SCHOOL_SOCIO_EMOTIONAL_RESULTS_ENDPOINT = 'api/socioEmotionalSkillTestResult/school/';
const DEFAULT_SELECTED_SCHOOL_TEST_RESULT =  0;

@Component({
  selector: 'app-school-socio-emotional-dashboard',
  templateUrl: './school-socio-emotional-dashboard.component.html',
  styleUrls: ['./school-socio-emotional-dashboard.component.scss']
})
export class SchoolSocioEmotionalDashboardComponent implements OnInit {
  schoolId = localStorage.getItem('schoolId') || '';

  socioEmotionalSkills: SocioEmotionalSkill[] = [];
  generalSocioEmotionalSkill: SocioEmotionalSkill;

  selectedSchoolTestResult: SocioEmotionalSkillTestResult;
  schoolTestResults: SocioEmotionalSkillTestResult[] = [];

  isLoading = false;
  isLoadingFilters = false;

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.loadDashboardData();
  }

  loadDashboardData(): void {
    this.isLoading = true;

    forkJoin({
      skills: this.apiService.get({ api: SOCIO_EMOTIONAL_SKILLS_ENDPOINT }),
      schoolResults: this.apiService.get({ api: `${SCHOOL_SOCIO_EMOTIONAL_RESULTS_ENDPOINT}${this.schoolId}` })
    }).subscribe({
      next: ({ skills, schoolResults }) => {
        this.socioEmotionalSkills = skills.filter(skill => !skill.isGeneral);
        this.generalSocioEmotionalSkill = skills.find(skill => skill.isGeneral);
        this.schoolTestResults = schoolResults;
        this.selectedSchoolTestResult = schoolResults[DEFAULT_SELECTED_SCHOOL_TEST_RESULT];
        this.isLoading = false;
        console.log('Dashboard data loaded successfully:', { skills, schoolResults });
      },
      error: (error) => {
        console.error('Error loading school dashboard data:', error);
        this.isLoading = false;
      }
    });
  }


  onFilterChanged(filter: SchoolSocioEmotionalDashboardFilter): void {
    this.isLoadingFilters = true;
    let apiUrl = `${SCHOOL_SOCIO_EMOTIONAL_RESULTS_ENDPOINT}${this.schoolId}?`;

    if (filter.name) {
      apiUrl += `name=${filter.name}`;
    }

    if (filter.grade) {
      apiUrl += `&grade=${filter.grade}`;
    }
    this.apiService.get({ api: apiUrl }).subscribe({
      next: (res: SocioEmotionalSkillTestResult[]) => {
        this.schoolTestResults = res;
        this.isLoadingFilters = false;
      },
      error: (error) => {
        console.error('Error fetching filtered results:', error);
        this.isLoadingFilters = false;
      }
    });
    console.log('Filter changed:', filter);

    if(filter.semester) {
      this.selectedSchoolTestResult = this.schoolTestResults.find(result => result.semesterName === filter.semester);
    }else{
      this.selectedSchoolTestResult = this.schoolTestResults[DEFAULT_SELECTED_SCHOOL_TEST_RESULT];
    }

  }
}
